import { NAVIGATION_URLS } from '@libs/core';
import { CurrentTierLevel } from '@libs/common-types';

const navigationUrls = NAVIGATION_URLS.velocity.account;
const tierMapping: { [key: string]: number } = {
    member: 0,
    bestie: 1,
    vipp: 2,
};
export interface NavigationItem {
    label: string;
    trackingKey: string;
    url: string;
    iconName: string;
}
export const navigationItems: NavigationItem[] = [
    { label: 'About you', trackingKey: 'account', url: navigationUrls.aboutYou, iconName: 'account-circle-outline' },
    { label: 'Orders', trackingKey: 'orders', url: navigationUrls.orderHistory, iconName: 'box-outline' },
    {
        label: 'Appointments',
        trackingKey: 'appointment',
        url: navigationUrls.servicesGrooming,
        iconName: 'calendar-outline',
    },
    { label: 'Autoship', trackingKey: 'autoship', url: navigationUrls.autoShip, iconName: 'autoship-outline' },
    { label: 'Payments', trackingKey: 'payments', url: navigationUrls.creditCards, iconName: 'wallet-outline' },
    { label: 'Offers', trackingKey: 'offers', url: navigationUrls.offers, iconName: 'offer-outline' },
    { label: 'Sign out', trackingKey: 'signout', url: navigationUrls.offers, iconName: 'signout-outline' },
];

export const getTierImage = (currentTierLevel: CurrentTierLevel) => {
    let tierImageAttribute = '';
    if (tierMapping[currentTierLevel.toLowerCase()] === 0) {
        tierImageAttribute = 'WEB-2098802-Oct23-Lacek_Icon-Member_DT';
    } else if (tierMapping[currentTierLevel.toLowerCase()] === 1) {
        tierImageAttribute = 'WEB-2098802-Oct23-Lacek_Icon-Bestie_DT';
    } else {
        tierImageAttribute = 'WEB-2098802-Oct23-Lacek_Icon-VIPP_DT';
    }
    return 'https://s7d2.scene7.com/is/image/PetSmart/' + tierImageAttribute;
};
